import React from 'react';
import './returnsignin.css';
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useLocation } from 'react-router-dom';

const ReturnSignIn = () => {
    const location = useLocation();
    const { key } = location.state || {};
    
    return (
        <div className='signin-return'>
            <div className='tvs-logo'>
                <img src={Image_Url.TVSLOGO} alt='' />
            </div>
            {key === "reset_password" ?
                <div className="reset-password-confirmation-container">
                    <h2>Password Reset Successful</h2>
                    <p>Your password has been successfully reset.</p>
                    <p>You can now sign in with your new password.</p>
                    <a href="/">Return To Sign In</a>
                </div>
                : <div className="reset-password-confirmation-container">
                    <p>Check your email for a link to reset your password. </p>
                    <p>If it doesn’t appear within a few minutes, </p>
                    <p>check your spam folder.</p>
                    <a href="/">Return To Sign In</a>
                </div>}
        </div>
    );
};

export default ReturnSignIn;
